import Logger from "./classes/Logger.class"
import Glossary from "./classes/Glossary.class";
const { jQuery: $ } = window;

window.GlossaryPlugin = new Glossary(new Logger("Glossary", "#9e3fbb"));

$(() => GlossaryPlugin.ready())

$(window).on("load", () => GlossaryPlugin.load());